import { render, staticRenderFns } from "./QuizTable.vue?vue&type=template&id=66d82427&"
import script from "./QuizTable.vue?vue&type=script&lang=js&"
export * from "./QuizTable.vue?vue&type=script&lang=js&"
import style0 from "./QuizTable.vue?vue&type=style&index=0&id=66d82427&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports